import { supabase } from "../../lib/supabase";
import { useState } from "react";
import { Input, Button, useToast } from "@dawa/ui";

export default function Reset() {
  const [email, setEmail] = useState("");
  const { addToast, Toasts } = useToast();

  return (
    <div className="auth-bg flex min-h-screen items-center justify-center p-4">
      <div className="flex w-full max-w-4xl flex-col items-center justify-center gap-8 md:flex-row">
        <div className="text-center text-2xl font-semibold text-white md:text-left md:w-1/2">
          Boostez votre SEO avec l'IA
        </div>
        <div className="w-full max-w-md space-y-4 rounded-xl bg-surface p-8 shadow-lg md:w-1/2">
          <h1 className="text-2xl font-bold">Réinitialiser le mot de passe</h1>
          <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button
            className="w-full bg-gradient-to-r from-blue-500 via-purple-500 to-teal-500 text-white"
            onClick={async () => {
              const { error } = await supabase.auth.resetPasswordForEmail(email);
              if (error) addToast(error.message, "error");
              else addToast("Email envoyé", "success");
            }}
          >
            Envoyer
          </Button>
          <Toasts />
        </div>
      </div>
    </div>
  );
}
